import { AxiosResponse } from 'axios';
import ListWithTotal from 'common/dto-types/list-with-total-dto';
import VenueDto from 'common/dto-types/venue-dto';
import VenueTypeDto from 'common/dto-types/venue-type-dto';
import axiosServices, { PaginationAndFiltersParams, buildQueryParams } from 'utils/axios';

export const VENUE_API_URL = '/venues';
const GET_VENUE_TYPES_URL = 'venueTypes';

export const createVenue = async (country: VenueDto): Promise<number | null | undefined> => {
    try {
        return await axiosServices.post(VENUE_API_URL, country).then((res) => res.data);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const updateVenue = async (country: VenueDto): Promise<number | null | undefined> => {
    try {
        return await axiosServices.put(VENUE_API_URL, country).then((res) => res.data);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const deleteVenue = async (id: string): Promise<number | null> => {
    try {
        return await axiosServices.delete(`${VENUE_API_URL}/${id}`).then((res) => res.status);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const fetchVenueList = async (
    params: PaginationAndFiltersParams,
): Promise<ListWithTotal<VenueDto> | null | undefined> => {
    try {
        const res = await axiosServices.get(`${VENUE_API_URL}${buildQueryParams(params)}`);
        return res.data;
    } catch (err) {
        // TODO: Implement a proper way to handle errors
        // https://fifadigital.atlassian.net/browse/FMH-2075
        console.error(err);
        return null;
    }
};

export const synchronizeFdcpStadiums = async (tournamentFdcpId: string): Promise<AxiosResponse | null | undefined> => {
    try {
        return await axiosServices.post(`${VENUE_API_URL}/syncFdcpStadiums/${tournamentFdcpId}`);
    } catch (err) {
        const errorResponse = err as AxiosResponse;
        if (errorResponse) return errorResponse;
        return null;
    }
};

export const fetchVenueTypes = async (): Promise<Array<VenueTypeDto> | null | undefined> => {
    try {
        const res = await axiosServices.get(GET_VENUE_TYPES_URL);
        return res.data;
    } catch (err) {
        console.error(err);
        return null;
    }
};
